import React from 'react';
import PropTypes from 'prop-types';
import CHEVRON from '@learningblocks/exp-constants/lib/Images/chevron_blue.svg';
import {Image} from '@learningblocks/storybook-components';

import style from './style.module.scss';

export function ChevronIcon(props) {
  const className = props.expanded ? style.chevron_less : style.chevron_more;

  return <Image className={className} src={CHEVRON} />;
}

ChevronIcon.propTypes = {
  /**
   * specifies if transcript is hidden or not
   */
  expanded: PropTypes.bool,
};
